import React from 'react';
import { Layout } from '../../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../../components/shared';

export const LungenfunktionPage = () => {
  return (
    <Layout>
      <PageHero
        title="Lungenfunktion (Spirometrie): Check für Ihre Atemwege"
        subtitle="Wir überprüfen die Kapazität und Funktion Ihrer Lunge, um Atemwegserkrankungen frühzeitig zu erkennen."
        backgroundImage="/images/Content_Behandlung_7.webp"
        ctaText="Lungenfunktionstermin buchen"
      />

      <ContentSection
        title="Gesunde Atmung – ein Lebenselixier"
        content="Die Spirometrie misst, wie viel Luft Sie ein- und ausatmen können und wie schnell dies geschieht. Dies ist entscheidend zur Diagnose und Überwachung von Erkrankungen wie Asthma, COPD oder anderen Lungenerkrankungen. Die Untersuchung ist unkompliziert und liefert wichtige Erkenntnisse über Ihre Atemgesundheit."
        image="/images/Content_Behandlung_7.webp"
        backgroundColor="white"
      />

      <SEOContent
        title="Lungenfunktionstests in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet Spirometrie zur Diagnostik von Atemwegserkrankungen im Raum Diez an."
      />

      <CTASection
        title="Haben Sie Probleme beim Atmen?"
        subtitle="Lassen Sie Ihre Lungenfunktion überprüfen. Vereinbaren Sie einen Termin."
        buttonText="Termin vereinbaren"
      />
    </Layout>
  );
};

export default LungenfunktionPage;
